<template>
  <el-card>
    <el-button-group class="mb-3"><search-form :fields="search" /></el-button-group>
    <el-table :data="orders" resource="orders">
      <!-- <el-table-column prop="id" label="ID" width="60" /> -->
      <el-table-column prop="created_at" label="下单时间" width="170" />
      <el-table-column label="订单信息" width="190">
        <template slot-scope="scope">
          <span>{{ scope.row.order_id }}</span>
          <br />
          <span>[{{ scope.row.order_type_text }}]</span>
          <el-tag
            :type="scope.row.audit_status === 2 ? 'danger' : scope.row.audit_status === 1 ? 'success' : 'warning'"
            size="small"
            disable-transitions
          >
            {{ scope.row.audit_status_text }}
          </el-tag>
          <br />
          <el-tag v-if="scope.row.audit_status === 1" size="small" disable-transitions>
            {{ scope.row.status_text }}
            <span type="success" v-if="scope.row.pick_up_order">[自提]</span>
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column align="center" header-align="center" label="账户信息" width="180">
        <template slot-scope="scope">
          <div v-if="scope.row.user">
            <span>{{ scope.row.user.real_name }}({{ scope.row.user.level_info.level_name }})</span>
            <br />
            <span>{{ scope.row.user.mobile }}</span>
            <br />
            <span>{{ scope.row.user.idcard_no }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="商品信息" width="300">
        <template slot-scope="scope">
          <div v-if="scope.row.items">
            <div v-for="item in scope.row.items" :key="item.id">
              <el-image style="width: 25px; height: 25px" :src="item.thumbnail_pic" :preview-src-list="[item.thumbnail_pic]">
                <div slot="error" class="image-slot"><i class="el-icon-picture-outline" /></div>
              </el-image>
              {{ item.name }}*{{ item.price }}*{{ item.nums }}
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="final_amount" label="金额" width="100" />

      <el-table-column label="收货信息" width="250">
        <template slot-scope="scope">
          <span>{{ scope.row.ship_name }}({{ scope.row.ship_mobile }})</span>
          <br />
          <span>{{ scope.row.ship_addr }}</span>
        </template>
      </el-table-column>
      <el-table-column label="快递信息" width="150">
        <template slot-scope="scope">
          <el-tag effect="plain" size="small">{{ scope.row.belong_delivery_user_name }}</el-tag>
          <div v-if="scope.row.status !== 0">
            <span>{{ scope.row.express_company_name }}</span>
            <br />
            <span>{{ scope.row.express_no }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <router-link :to="'/orders/' + scope.row.id + '/edit'"><el-button type="text" size="small">查看详情</el-button></router-link>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer"><pagination :page="page" /></div>
  </el-card>
</template>

<script>
import SearchForm from '@c/SearchForm'
import Pagination from '@c/Pagination'
import { getOrders } from '@/api/orders'

export default {
  name: 'Index',
  components: {
    SearchForm,
    Pagination,
  },
  data() {
    return {
      search: [
        // {
        //   field: 'user_id',
        //   label: '当前用户',
        //   invisible: true
        // },
        {
          field: 'order_id',
          label: '订单号',
        },
        {
          field: 'title',
          label: '订单名称',
        },
        {
          field: 'order_type',
          label: '订单类型',
          type: 'el-select',
          options: [
            { id: 0, name: '普单订单' },
            { id: 1, name: '报单订单' },
            { id: 2, name: '积分订单' },
          ],
          labelField: 'name', // 默认为 name
          valueField: 'id', // 默认为 id
        },
        {
          field: 'audit_status',
          label: '审核状态',
          type: 'el-select',
          options: [
            { id: 0, name: '待审核' },
            { id: 1, name: '审核成功' },
            { id: 2, name: '拒绝' },
          ],
          labelField: 'name', // 默认为 name
          valueField: 'id', // 默认为 id
        },
        {
          field: 'status',
          label: '发货状态',
          type: 'el-select',
          options: [
            { id: 0, name: '待发货' },
            { id: 1, name: '发货中' },
            { id: 2, name: '已完成' },
          ],
          labelField: 'name', // 默认为 name
          valueField: 'id', // 默认为 id
        },
        {
          field: 'created_at',
          label: '获得时间',
          type: 'el-date-picker',
        },
      ],
      orders: [],
      page: null,
    }
  },
  created() {},
  watch: {
    $route: {
      async handler(newVal) {
        newVal.query.user_id = this.$route.params['id']
        newVal.query.isFilter = true
        const {
          data: { data, meta },
        } = await getOrders(newVal.query)
        this.orders = data
        this.page = meta
      },
      immediate: true,
    },
  },
}
</script>
